import React, { useMemo, useState } from "react";
import TableWidget from "../components/TableWidget.jsx";

export default function GestionEquipes({ user }) {
  // --- Données de démonstration (remplacer par Firestore plus tard) ---
  const [teams, setTeams] = useState([
    { id: "t-001", name: "Ops Contrats", owner: "ayoub@form2doc.com", members: 6, projects: 3, status: "Active" },
    { id: "t-002", name: "Compta & Factures", owner: "fatima@cabinet.ma", members: 4, projects: 2, status: "Active" },
    { id: "t-003", name: "Notariat", owner: "mehdi@office.ma", members: 8, projects: 5, status: "Suspendue" },
  ]);
  const [members, setMembers] = useState([
    { id: "u-101", name: "Ayoub Fenane", email: "ayoub@form2doc.com", role: "Admin", team: "Ops Contrats", status: "Actif" },
    { id: "u-102", name: "Fatima Zahra", email: "fatima@cabinet.ma", role: "Manager", team: "Compta & Factures", status: "Actif" },
    { id: "u-103", name: "Mehdi B.", email: "mehdi@office.ma", role: "Éditeur", team: "Notariat", status: "Invité" },
  ]);
  const [invites, setInvites] = useState([
    { id: "i-201", email: "invite1@exemple.com", team: "Ops Contrats", role: "Éditeur", sentAt: "2025-11-02" },
  ]);

  const kpis = useMemo(() => ([
    { label: "Équipes", value: teams.length, delta: "+1 ce mois" },
    { label: "Membres", value: members.length, delta: "+2 ce mois" },
    { label: "Invitations en attente", value: invites.length, delta: "" },
  ]), [teams.length, members.length, invites.length]);

  // --- Modaux ---
  const [showTeamModal, setShowTeamModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);

  const [draftTeam, setDraftTeam] = useState({ name: "", owner: user?.email || "", status: "Active" });
  const [draftInvite, setDraftInvite] = useState({ email: "", team: "", role: "Éditeur" });

  const addTeam = (e) => {
    e?.preventDefault?.();
    if (!draftTeam.name) return;
    setTeams(prev => [...prev, { id: `t-${Date.now()}`, members: 1, projects: 0, ...draftTeam }]);
    setDraftTeam({ name: "", owner: user?.email || "", status: "Active" });
    setShowTeamModal(false);
  };

  const sendInvite = (e) => {
    e?.preventDefault?.();
    if (!draftInvite.email || !draftInvite.team) return;
    setInvites(prev => [...prev, { id: `i-${Date.now()}`, sentAt: new Date().toISOString().slice(0,10), ...draftInvite }]);
    setDraftInvite({ email: "", team: "", role: "Éditeur" });
    setShowInviteModal(false);
  };

  const TEAM_COLS = [
    { key: "name", label: "Équipe" },
    { key: "owner", label: "Propriétaire" },
    { key: "members", label: "Membres" },
    { key: "projects", label: "Projets" },
    { key: "status", label: "Statut" },
    { key: "__actions", label: "Actions", isActions: true },
  ];

  const TEAM_ROWS = teams.map(t => ({
    ...t,
    __actions: (
      <div className="actions">
        <div className="action-btn" title="Renommer" onClick={() => {
          const name = prompt("Nouveau nom de l'équipe", t.name);
          if (!name) return;
          setTeams(prev => prev.map(x => x.id === t.id ? { ...x, name } : x));
        }}><i className="fas fa-pen"></i></div>
        <div className="action-btn" title="Supprimer" onClick={() => {
          if (!confirm(`Supprimer l'équipe "${t.name}" ?`)) return;
          setTeams(prev => prev.filter(x => x.id !== t.id));
        }}><i className="fas fa-trash"></i></div>
      </div>
    )
  }));

  const MEMBER_COLS = [
    { key: "name", label: "Nom" },
    { key: "email", label: "Email" },
    { key: "role", label: "Rôle" },
    { key: "team", label: "Équipe" },
    { key: "status", label: "Statut" },
    { key: "__actions", label: "Actions", isActions: true },
  ];

  const MEMBER_ROWS = members.map(m => ({
    ...m,
    __actions: (
      <div className="actions">
        <div className="action-btn" title="Changer le rôle" onClick={() => {
          const role = prompt("Rôle (Admin/Manager/Éditeur/Lecteur)", m.role) || m.role;
          setMembers(prev => prev.map(x => x.id === m.id ? { ...x, role } : x));
        }}><i className="fas fa-user-shield"></i></div>
        <div className="action-btn" title="Retirer" onClick={() => {
          if (!confirm(`Retirer ${m.name} ?`)) return;
          setMembers(prev => prev.filter(x => x.id !== m.id));
        }}><i className="fas fa-user-minus"></i></div>
      </div>
    )
  }));

  return (
    <div className="main-content">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">Gestion des Équipes</h1>
        <div className="quick-actions">
          <button className="btn btn-outline" onClick={() => setShowInviteModal(true)}>
            <i className="fas fa-paper-plane"></i> Inviter un membre
          </button>
          <button className="btn btn-primary" onClick={() => setShowTeamModal(true)}>
            <i className="fas fa-users"></i> Nouvelle équipe
          </button>
        </div>
      </div>

      {/* KPI */}
      <div className="widgets-grid">
        {kpis.map((k, idx) => (
          <div className="widget stat-widget" key={idx}>
            <div className="widget-header">
              <div className="widget-title">{k.label}</div>
            </div>
            <div className="stat-value">{k.value}</div>
            {k.delta && (
              <div className="stat-change positive">
                <i className="fas fa-arrow-trend-up"></i> {k.delta}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Tables */}
      <div className="table-container">
        <div className="table-header">
          <div className="table-title">Équipes</div>
          <div className="table-filters">
            <button className="btn" onClick={() => setShowTeamModal(true)}><i className="fas fa-plus"></i> Ajouter</button>
          </div>
        </div>
        <div className="table-body">
          <TableWidget rows={TEAM_ROWS} columns={TEAM_COLS} pageSize={7} />
        </div>
      </div>

      <div className="table-container">
        <div className="table-header">
          <div className="table-title">Membres</div>
          <div className="table-filters">
            <button className="btn" onClick={() => setShowInviteModal(true)}><i className="fas fa-paper-plane"></i> Inviter</button>
          </div>
        </div>
        <div className="table-body">
          <TableWidget rows={MEMBER_ROWS} columns={MEMBER_COLS} pageSize={7} />
        </div>
      </div>

      {/* Invitations */}
      <div className="table-container">
        <div className="table-header">
          <div className="table-title">Invitations en attente</div>
        </div>
        <div className="table-body">
          <TableWidget
            pageSize={5}
            columns={[
              { key: "email", label: "Email" },
              { key: "team", label: "Équipe" },
              { key: "role", label: "Rôle" },
              { key: "sentAt", label: "Envoyée le" },
              { key: "__actions", label: "Actions", isActions: true },
            ]}
            rows={invites.map(i => ({
              ...i,
              __actions: (
                <div className="actions">
                  <div className="action-btn" title="Renvoyer" onClick={() => alert("Lien d'invitation renvoyé ✅") }><i className="fas fa-redo"></i></div>
                  <div className="action-btn" title="Annuler" onClick={() => setInvites(prev => prev.filter(x => x.id !== i.id)) }><i className="fas fa-times"></i></div>
                </div>
              )
            }))}
          />
        </div>
      </div>

      {/* Modal Nouvelle équipe */}
      {showTeamModal && (
        <div className="modal" role="dialog" aria-modal="true">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Nouvelle équipe</div>
              <div className="modal-close" onClick={() => setShowTeamModal(false)}><i className="fas fa-times"></i></div>
            </div>
            <form className="modal-body" onSubmit={addTeam}>
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">Nom de l'équipe</label>
                  <input className="form-input" value={draftTeam.name} onChange={e => setDraftTeam(t => ({ ...t, name: e.target.value }))} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Propriétaire</label>
                  <input className="form-input" value={draftTeam.owner} onChange={e => setDraftTeam(t => ({ ...t, owner: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Statut</label>
                  <select className="form-select" value={draftTeam.status} onChange={e => setDraftTeam(t => ({ ...t, status: e.target.value }))}>
                    <option>Active</option>
                    <option>Suspendue</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowTeamModal(false)}>Annuler</button>
                <button type="submit" className="btn btn-primary">Créer</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Invitation */}
      {showInviteModal && (
        <div className="modal" role="dialog" aria-modal="true">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Inviter un membre</div>
              <div className="modal-close" onClick={() => setShowInviteModal(false)}><i className="fas fa-times"></i></div>
            </div>
            <form className="modal-body" onSubmit={sendInvite}>
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-input" value={draftInvite.email} onChange={e => setDraftInvite(v => ({ ...v, email: e.target.value }))} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Équipe</label>
                  <select className="form-select" value={draftInvite.team} onChange={e => setDraftInvite(v => ({ ...v, team: e.target.value }))} required>
                    <option value="">— choisir —</option>
                    {teams.map(t => <option key={t.id} value={t.name}>{t.name}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Rôle</label>
                  <select className="form-select" value={draftInvite.role} onChange={e => setDraftInvite(v => ({ ...v, role: e.target.value }))}>
                    <option>Admin</option>
                    <option>Manager</option>
                    <option>Éditeur</option>
                    <option>Lecteur</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowInviteModal(false)}>Annuler</button>
                <button type="submit" className="btn btn-primary">Envoyer l'invitation</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}